<template>
    <div class="cca-mgmt-page p-3">
        
        <!-- ສ່ວນການຄົ້ນຫາ ແລະ ຈັດການຂໍ້ມູນ -->
        <b-card class="shadow-sm border-0 mb-4 bg-white rounded-lg">
            <template #header>
                <div class="d-flex align-items-center justify-content-between py-1">
                    <h5 class="mb-0 text-primary font-weight-bold">
                        <b-icon icon="clipboard-check-fill" class="mr-2"></b-icon>
                        ຈັດການຂໍ້ມູນແບບສອບຖາມ (CCA)
                    </h5>
                    <div class="d-flex gap-2">
                        <b-button variant="outline-success" @click="exportExcel" class="px-3 shadow-sm font-weight-bold mr-2" :disabled="exporting">
                            <b-icon :icon="exporting ? 'hourglass-split' : 'file-earmark-excel-fill'" class="mr-1"></b-icon>
                            {{ exporting ? 'ກຳລັງ Export...' : 'Export Excel' }}
                        </b-button>
                        <b-button variant="success" @click="addnew" class="px-3 shadow-sm font-weight-bold">
                            <b-icon icon="plus-circle" class="mr-1"></b-icon> ເພີ່ມແບບສອບຖາມໃໝ່
                        </b-button>
                    </div>
                </div>
            </template>

            <b-row align-v="end">
                <b-col cols="12" md="3" class="mb-2 mb-md-0">
                    <label class="small text-muted font-weight-bold mb-1">ຄົ້ນຫາຕາມ:</label>
                    <b-form-select v-model="field" :options="searchOptions" class="rounded-pill border-primary-light">
                        <template #first>
                            <b-form-select-option value="" disabled>-- ເລືອກຫົວຂໍ້ --</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col cols="12" md="3" class="mb-2 mb-md-0">
                    <label class="small text-muted font-weight-bold mb-1">ຄຳຄົ້ນຫາ:</label>
                    <b-form-input type="text" v-model="find" placeholder="ປ້ອນຂໍ້ມູນຄົ້ນຫາ..." class="rounded-pill"></b-form-input>
                </b-col>
                <b-col cols="12" md="3" class="mb-2 mb-md-0">
                    <label class="small text-muted font-weight-bold mb-1">ວັນທີເກັບຂໍ້ມູນ:</label>
                    <b-form-datepicker v-model="fdate" placeholder="ເລືອກວັນທີ" locale="lo" class="rounded-pill"></b-form-datepicker>
                </b-col>
                <b-col cols="12" md="3">
                    <b-button variant="primary" @click="onSearch" block class="rounded-pill shadow-sm font-weight-bold">
                        <b-icon icon="search" class="mr-1"></b-icon> ຄົ້ນຫາຂໍ້ມູນ
                    </b-button>
                </b-col>
            </b-row>
        </b-card>

        <!-- ຕາຕະລາງສະແດງຂໍ້ມູນ -->
        <b-card no-body class="shadow-sm border-0 overflow-hidden rounded-lg">
            <b-table 
                head-variant="light" 
                hover 
                striped
                :fields="tableFields" 
                :items="items" 
                class="cca-table mb-0" 
                responsive="sm"
            >
                <template #cell(index)="data">
                    <span class="text-muted small font-weight-bold">{{ data.index + 1 }}</span>
                </template>

                <template #cell(info)="data">
                    <div class="py-1">
                        <div class="font-weight-bold text-dark">
                            {{ gv(data.item, 'schoolName','school','meta_schoolName') }}
                        </div>
                        <div class="small text-muted">
                            <b-icon icon="geo-alt-fill" class="mr-1"></b-icon>
                            {{ gv(data.item,'villageName','village','meta_village') }},
                            {{ gv(data.item,'district','meta_district') }},
                            {{ gv(data.item,'province') }}
                        </div>
                        <div class="small text-muted">
                            <b-icon icon="building" class="mr-1"></b-icon>
                            {{ gv(data.item,'schoolCode','meta_schoolCode') }}
                        </div>
                    </div>
                </template>

                <template #cell(collectionDate)="data">
                    <span class="small">{{ gv(data.item,'collectionDate','date','meta_date') | formatdate }}</span>
                </template>

                <template #cell(collector)="data">
                    <div class="small font-weight-bold">
                        {{ gv(data.item,'collectorName','interviewer','meta_interviewer') }}
                    </div>
                    <div class="small text-muted">{{ gv(data.item,'collectorPhone') || '—' }}</div>
                </template>

                <template #cell(modify)="data">
                    <div class="small font-weight-bold">{{ data.item.update_by }}</div>
                    <div class="small text-muted">{{ data.item.update_at | formatdate }}</div>
                </template>

                <template #cell(action)="data">
                    <div class="d-flex justify-content-center align-items-center">
                        <b-button variant="link" size="sm" class="text-primary mr-2 p-0 action-btn" @click="view(data.item._id)" v-b-tooltip.hover title="ເບິ່ງລາຍລະອຽດ">
                            <b-icon icon="eye-fill" font-scale="1.2"></b-icon>
                        </b-button>
                        <b-button variant="link" size="sm" class="text-info mr-2 p-0 action-btn" @click="edit(data.item._id)" v-b-tooltip.hover title="ແກ້ໄຂ">
                            <b-icon icon="pencil-square" font-scale="1.2"></b-icon>
                        </b-button>
                        <b-button variant="link" size="sm" class="text-danger p-0 action-btn" @click="del(data.item._id)" v-b-tooltip.hover title="ລຶບ">
                            <b-icon icon="trash-fill" font-scale="1.2"></b-icon>
                        </b-button>
                    </div>
                </template>
            </b-table>
        </b-card>

        <!-- Loading ຂໍ້ມູນແບບ Infinite -->
        <div class="mt-4 pb-5 text-center">
            <infinite-loading @infinite="infiniteHandler" spinner="spiral">
                <div slot="spinner" class="py-3">
                    <b-spinner variant="primary" small></b-spinner>
                    <span class="ml-2 text-muted small">ກຳລັງໂຫຼດຂໍ້ມູນ...</span>
                </div>
                <div slot="no-more" class="py-3 text-muted small italic">-- ສິ້ນສຸດຂໍ້ມູນ --</div>
                <div slot="no-results" class="py-3 text-muted small italic">-- ບໍ່ພົບຂໍ້ມູນ --</div>
            </infinite-loading>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";
import moment from 'moment';

export default {
    name: 'CCAManagement',
    components: { InfiniteLoading },
    data() {
        return {
            page: 0,
            field: 'schoolName',
            find: '',
            fdate: '',
            items: [],
            user: {},
            exporting: false,
            searchOptions: [
                { value: 'schoolName',    text: 'ຊື່ໂຮງຮຽນ' },
                { value: 'villageName',   text: 'ຊື່ບ້ານ' },
                { value: 'district',      text: 'ເມືອງ' },
                { value: 'province',      text: 'ແຂວງ' },
                { value: 'collectorName', text: 'ຊື່ຜູ້ເກັບຂໍ້ມູນ' },
                { value: 'schoolCode',    text: 'ລະຫັດໂຮງຮຽນ' }
            ],
            tableFields: [
                { key: 'index', label: 'ລຳດັບ', thClass: 'text-center', tdClass: 'text-center' },
                { key: 'info', label: 'ຂໍ້ມູນໂຮງຮຽນ / ທີ່ຕັ້ງ' },
                { key: 'collector', label: 'ຜູ້ເກັບຂໍ້ມູນ' },
                { key: 'collectionDate', label: 'ວັນທີເກັບຂໍ້ມູນ', thClass: 'text-center', tdClass: 'text-center' },
                { key: 'modify', label: 'ຜູ້ແກ້ໄຂ' },
                { key: 'action', label: 'ຈັດການ', thClass: 'text-center', tdClass: 'text-center' }
            ]
        }
    },
    filters: {
        formatdate(value) {
            if (value) return moment(String(value)).format('DD/MM/YYYY');
            return '—';
        }
    },
    created() {
        const login = localStorage.getItem("Login");
        if (login) this.user = JSON.parse(login);
    },
    methods: {
        // ດຶງຄ່າຈາກ record ໂດຍລອງ key ຫຼາຍອັນ (ຮອງຮັບທັງ web ແລະ mobile)
        gv(item, ...keys) {
            if (!item) return '';
            for (const k of keys) {
                const v = item[k];
                if (v !== undefined && v !== null && v !== '') return String(v);
            }
            return '—';
        },
        async fetchData(offset = 0) {
            const baseUrl = this.$store.getters.getBaseUrl;
            const params = `?offset=${offset}&fld=${this.field}&find=${this.find}&fdate=${this.fdate}&table=CCA_Assessments`;
            // ໝາຍເຫດ: 999 ແມ່ນ placeholder ສໍາລັບ menu_id ຖ້າຈໍາເປັນຕ້ອງໃຊ້ຕາມ pattern ເດີມ
            return axios.get(`${baseUrl}/fech_CCA${params}`, {
                headers: { 'Authorization': 'Bearer ' + this.user.login_hash }
            });
        },
        infiniteHandler($state) {
            this.fetchData(this.page).then(response => {
                if (response.data.items && response.data.items.length > 0) {
                    this.page++;
                    this.items = this.items.concat(response.data.items);
                    $state.loaded();
                } else {
                    $state.complete();
                }
            }).catch(() => $state.complete());
        },
        onSearch() {
            this.page = 0;
            this.items = [];
            this.fetchData(0).then(response => {
                this.items = response.data.items || [];
                this.page = 1;
            });
        },
        addnew() {
            this.$router.push('/cca-form');
        },
        view(id) {
            this.$router.push({ path: '/cca-detail', query: { id: id } });
        },
        edit(id) {
            this.$router.push({ path: '/cca-form', query: { id: id } });
        },
        async exportExcel() {
            this.exporting = true;
            try {
                const res = await axios.get(
                    this.$store.getters.getBaseUrl + `/export_cca_all?fld=${this.field}&find=${this.find}`,
                    { headers: { 'Authorization': 'Bearer ' + this.user.login_hash } }
                );
                const rows = res.data.items || [];
                if (!rows.length) {
                    this.$bvToast.toast('ບໍ່ມີຂໍ້ມູນສຳລັບ Export', { title: 'ແຈ້ງເຕືອນ', variant: 'warning' });
                    return;
                }
                this._downloadExcel(rows);
                this.$bvToast.toast('Export Excel ສຳເລັດ', { title: 'ສຳເລັດ', variant: 'success' });
            } catch (e) {
                console.error(e);
                this.$bvToast.toast('ເກີດຂໍ້ຜິດພາດໃນການ Export', { title: 'Error', variant: 'danger' });
            } finally {
                this.exporting = false;
            }
        },
        _downloadExcel(rows) {
            const cols = [
                { key: '_id',            label: 'ID' },
                { key: 'schoolName',     label: 'ຊື່ໂຮງຮຽນ' },
                { key: 'schoolCode',     label: 'ລະຫັດໂຮງຮຽນ' },
                { key: 'district',       label: 'ເມືອງ' },
                { key: 'province',       label: 'ແຂວງ' },
                { key: 'villageName',    label: 'ບ້ານ' },
                { key: 'villageCode',    label: 'ລະຫັດບ້ານ' },
                { key: 'collectorName',  label: 'ຜູ້ເກັບຂໍ້ມູນ' },
                { key: 'collectorPhone', label: 'ເບີໂທ' },
                { key: 'collectionDate', label: 'ວັນທີເກັບ' },
                { key: 'lat',            label: 'GPS Lat' },
                { key: 'lon',            label: 'GPS Lon' },
                { key: 'q2_1', label: 'ຈຳນວນຜູ້ເຂົ້າຮ່ວມ' },
                { key: 'q2_2', label: 'ຄົວເຮືອນ' },
                { key: 'q2_3', label: 'ປະຊາກອນທັງໝົດ' },
                { key: 'q2_4', label: 'ແມ່ຍິງ' },
                { key: 'q2_5', label: 'ກຸ່ມພາສາ' },
                { key: 'q2_6', label: 'ຊົນເຜົ່າ' },
                { key: 'q3_1', label: 'ລະດັບການເຂົ້າເຖິງ' },
                { key: 'q3_3', label: 'ຄວາມສະດວກການເຂົ້າເຖິງ' },
                { key: 'q3_4', label: 'ໄລຍະໄປຕະຫຼາດ' },
                { key: 'q3_5', label: 'ລາຍຮັບສ່ວນໃຫຍ່' },
                { key: 'q3_7', label: 'ເຄີຍໄພພິບັດ?' },
                { key: 'q3_13', label: 'ຂາດອາຫານ?' },
                { key: 'q4_2', label: 'ມີສວນຄົວ?' },
                { key: 'q4_3', label: 'ມີລ້ຽງສັດ?' },
                { key: 'q4_4', label: 'ມີໜອງປາ?' },
                { key: 'q4_5', label: 'ແຫຼ່ງນ້ຳ' },
                { key: 'q5_1', label: 'ຮູບແບບປະກອບສ່ວນ' },
                { key: 'q6_1', label: 'ສະມາຊິກ ຄພສບ' },
                { key: 'q6_2', label: 'ແມ່ຍິງໃນ ຄພສບ' },
                { key: 'q6_3', label: 'ມີລະບຽບ ຄພສບ?' },
                { key: 'q6_4', label: 'ມີການປະຊຸມ?' },
                { key: 'q8_1', label: 'ໝາຍເຫດ' },
                { key: 'timestamp', label: 'ວັນທີບັນທຶກ' },
            ];

            const esc = v => {
                if (v === undefined || v === null) return '';
                if (Array.isArray(v)) return v.join(', ');
                const s = String(v).replace(/</g, '&lt;').replace(/>/g, '&gt;');
                return s;
            };

            let html = '<html><head><meta charset="UTF-8"></head><body>';
            html += '<table border="1" style="border-collapse:collapse;font-family:Arial,sans-serif;font-size:12px">';
            html += '<tr style="background:#1B4F72;color:#fff">';
            cols.forEach(c => { html += `<th style="padding:6px 10px;white-space:nowrap">${c.label}</th>`; });
            html += '</tr>';
            rows.forEach((row, idx) => {
                const bg = idx % 2 === 0 ? '#fff' : '#f5f8ff';
                html += `<tr style="background:${bg}">`;
                cols.forEach(c => {
                    html += `<td style="padding:5px 9px;border:1px solid #ddd">${esc(row[c.key])}</td>`;
                });
                html += '</tr>';
            });
            html += '</table></body></html>';

            const blob = new Blob([html], { type: 'application/vnd.ms-excel;charset=utf-8' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `CCA_Export_${new Date().toISOString().slice(0,10)}.xls`;
            a.click();
            URL.revokeObjectURL(url);
        },
        del(id) {
            this.$bvModal.msgBoxConfirm('ທ່ານແນ່ໃຈບໍວ່າຕ້ອງການລົບຂໍ້ມູນນີ້?', {
                title: 'ຢືນຢັນການລົບ',
                okVariant: 'danger',
                okTitle: 'ລົບອອກ',
                cancelTitle: 'ຍົກເລີກ',
                centered: true,
                buttonSize: 'sm'
            }).then(value => {
                if (value) {
                    const params = { table: 'CCA_Assessments', code: id, fields: { status: 'D', del_by: this.user.username, del_date: new Date() } };
                    axios.post(this.$store.getters.getBaseUrl + '/del', params, {
                        headers: { 'Authorization': 'Bearer ' + this.user.login_hash }
                    }).then(res => {
                        if (res.data.code == 1) {
                            this.$bvToast.toast('ລົບຂໍ້ມູນສຳເລັດແລ້ວ', { title: 'ແຈ້ງເຕືອນ', variant: 'success', appendToast: true });
                            this.onSearch();
                        }
                    });
                }
            });
        }
    }
};
</script>

<style scoped>
.cca-mgmt-page {
    background-color: #f4f7f6;
    min-height: 100vh;
    font-family: 'Noto Sans Lao', sans-serif;
}
.rounded-lg { border-radius: 12px !important; }
.cca-table { font-size: 0.9rem; }
.cca-table ::v-deep th, .cca-table ::v-deep td {
    white-space: nowrap !important;
    vertical-align: middle !important;
    padding: 12px 15px !important;
}
.action-btn { transition: transform 0.2s ease; }
.action-btn:hover { transform: scale(1.2); }
</style>